import React, {
  forwardRef, memo, useContext,
} from 'react';
import PropTypes from 'prop-types';
import {
  Alert, AlertTitle, Box, Paper, TableBody, TableContainer, Typography,
} from '@mui/material';
import {
  StyledListerTable,
} from './styles';
import ListerContext from '../../context';
import Loader from '../../../../components/MaterialUI/loader';
// eslint-disable-next-line import/no-cycle
import FilterPanel from '../filterPanel';

const TableListerFactory = ({
  CommandPanel,
  RowComponent,
  HeaderComponent,
  ContextMenuComponent,
}) => {
  // При необходимости переместить одно ищ указанныъ нижу свойств в
  // context - удалять из свойств. Т.е. свойство должно быть или в
  // props или в context, но никак и там и там.
  const TableLister = forwardRef(({
    visibleColumns,
    openedItems,
    onRowFocus,
    onSetOrder,
    order,
    loading,
    err,
    onReoload,
    onScroll,
    areaSize,
    columnSizes,
    filterOpened,
    onResizeColumn,
    onResetColumnSize,
    onSetColumnSizes,
    maxItemLevel,
    commandPanelRef,
  }, ref) => {
    const {
      onShowCtxMenu,
      permissions,
      actions,
      selectedRows,
      items,
      localFilter,
      messages,
      filteringFields,
      meta,
      // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useContext(ListerContext);
    return (
      <>
        {meta && meta.label && (
          <Typography variant="h5" mb={1} color="secondary.main">
            {meta.label}
          </Typography>
        )}
        {!!messages.length && messages.map((m) => (
          <Alert
            key={m.id}
            severity={m.variant || 'info'}
            onClose={() => actions.onDeleteMessage(m.id)}
          >
            {m.title && (
              <AlertTitle>{m.title}</AlertTitle>
            )}
            {m.text}
          </Alert>
        ))}
        <Box>
          <CommandPanel
            ref={commandPanelRef}
          />
          <TableContainer
            ref={ref}
            sx={{
              overflow: 'auto',
              // width: areaSize.width,
              height: areaSize.height,
            }}
            onScroll={onScroll}
            component={Paper}
          >
            {loading && (
            <Loader text="Завантаження" />
            )}
            <StyledListerTable
              size="medium"
              stickyHeader
              padding="normal"
            >
              <HeaderComponent
                columns={visibleColumns}
                onSetOrder={onSetOrder}
                order={order}
                columnSizes={columnSizes}
                onResizeColumn={onResizeColumn}
                onResetColumnSize={onResetColumnSize}
                onSetColumnSizes={onSetColumnSizes}
                permissions={permissions}
                maxItemLevel={maxItemLevel}
                localFilter={localFilter}
              />
              <TableBody>
                {items.map((row, i) => (
                  <RowComponent
                    tabIndex={i + 1}
                    key={row.id}
                    row={row}
                    columns={visibleColumns}
                    onFocus={onRowFocus}
                    selected={selectedRows.includes(row.id)}
                    onContextMenu={ContextMenuComponent ? onShowCtxMenu : null}
                    permissions={permissions}
                    actions={actions}
                    isOpened={openedItems.includes(row.id)}
                  />
                ))}
              </TableBody>
            </StyledListerTable>

            {ContextMenuComponent && (
            <ContextMenuComponent />
            )}
            {err && (
            <Alert severity="error" onClose={onReoload}>
              <AlertTitle>
                {err}
              </AlertTitle>
            </Alert>
            )}
          </TableContainer>
          <FilterPanel
            show={filterOpened}
            filteringFields={filteringFields}
            filter={localFilter}
            onSetFilter={actions.onSetFilter}
          />
        </Box>
      </>
    );
  });

  TableLister.propTypes = {
    visibleColumns: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
    })).isRequired,
    order: PropTypes.shape({
      column: PropTypes.string,
      // direction: PropTypes.oneOf(Object.values(directions)),
    }).isRequired,
    loading: PropTypes.bool,
    err: PropTypes.string,
    onRowFocus: PropTypes.func.isRequired,
    onSetOrder: PropTypes.func.isRequired,
    onReoload: PropTypes.func.isRequired,
    areaSize: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    onScroll: PropTypes.func.isRequired,
    columnSizes: PropTypes.shape({}),
    onResizeColumn: PropTypes.func.isRequired,
    onResetColumnSize: PropTypes.func.isRequired,
    onSetColumnSizes: PropTypes.func.isRequired,
    openedItems: PropTypes.arrayOf(
      PropTypes.number,
    ),
    maxItemLevel: PropTypes.number,
    commandPanelRef: PropTypes.shape({}),
    filterOpened: PropTypes.bool.isRequired,
  };

  TableLister.defaultProps = {
    loading: false,
    err: null,
    areaSize: null,
    columnSizes: {},
    openedItems: [],
    maxItemLevel: 0,
    commandPanelRef: null,
  };
  return memo(TableLister);
};

export default TableListerFactory;
